import Dedicated from './pricing/dedicated';
import PricingPlan from './pricing/pricing-plan';
import Customerssays from './home-sections/Customerssays';
import Partnerslogos from './home-sections/Partnerslogos';
import Popup from './home-sections/Popupm'


export default function Pricing() {
    return (
        <div>
            <Dedicated />
            <PricingPlan/>
            <Customerssays/>
            <Partnerslogos/>
            <Popup/>
        </div>
    )
}
